import * as React from 'react';
import { useTranslation } from 'react-i18next';


const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="d-flex justify-content-center w-100 pl-15vw">
        <div className="dashboard-admin-container">
            <h2>{t("WelcomeBackOffice")}</h2>
        </div>
      </div>
    </>
  )
}

export default Dashboard;
